import {
  Box,
  Flex,
  useCheckbox,
  useCheckboxGroup,
  Text,
} from "@chakra-ui/react";
import { FC } from "react";
import { FieldError } from "react-hook-form";

import { Config } from "@ud/config/prodeje/config";

type ClickableItemsProps = {
  config: Config;
  extValue: Array<string>;
  setValue: (value: Array<string>) => void;
  error?: FieldError;
};

export const ClickableItems: FC<ClickableItemsProps> = ({
  config,
  extValue,
  setValue,
  error,
}) => {
  const { getCheckboxProps } = useCheckboxGroup({
    defaultValue: extValue,
    onChange: (value: Array<string>) => setValue(value),
  });

  return (
    <>
      <Flex wrap="wrap">
        {Object.entries(config).map(([id, { translationId }]) => {
          const checkbox = getCheckboxProps({ value: id });

          return (
            <RadioCard key={id} {...checkbox}>
              {translationId}
            </RadioCard>
          );
        })}
      </Flex>
      {error?.message && <Text variant="form-error">{error.message}</Text>}
    </>
  );
};

const RadioCard: FC<{
  [x: string]: any;
  onChange: (eventOrValue: any) => void;
}> = (props) => {
  const { getInputProps, getCheckboxProps } = useCheckbox(props);

  const input = getInputProps();
  const checkbox = getCheckboxProps();

  return (
    <Box as="label">
      <input {...input} />
      <Box
        {...checkbox}
        cursor="pointer"
        borderWidth="1px"
        borderRadius="md"
        borderColor="ud-grey-300"
        bg="ud-white"
        _checked={{
          bg: "ud-primary-100",
          borderColor: "ud-primary",
        }}
        px="18px"
        py="8px"
        mr="10px"
        mb="10px"
      >
        {props.children}
      </Box>
    </Box>
  );
};
